export default "__VITE_ASSET__DdKY5Vmi__"